import './Certificates.css';
import './scrollAnimations.css';
import { useEffect } from 'react';
import useScrollAnimation from './useScrollAnimation';

function Certificates({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useScrollAnimation();

  const certs = [
    {
      title: "Collaborative Project Presentation and Prototype Exhibition",
      org: "FAITH Colleges",
      date: "2026"
    },
    {
      title: "Building Sustainable Future: Empowering Communities through HIV Awareness and Education",
      org: "Seminar Participation",
      date: "Recent"
    },
    {
      title: "Building Intelligence: Where Computer Engineering Meets Data Science",
      org: "Webinar",
      date: "November 2025"
    },
    {
      title: "Design of RISC-V Microprocessors",
      org: "Webinar",
      date: "November 6, 2025"
    },
    {
      title: "Arduino Workshop Part 1: Arduino Coding Skills Preparation for Hardware",
      org: "FAITH Computer Engineering Society",
      date: "September 8, 2025"
    },
    {
      title: "Engineering the Future: Career Stories and Industry Insights",
      org: "First Asia Institute of Technology and Humanities, Tanauan City",
      date: "March 29, 2025"
    },
    {
      title: "Arduino Workshop Part 2: Integration of Hardware",
      org: "FAITH Computer Engineering Society",
      date: "September 24, 2025"
    },
    {
      title: "3rd Annual Conference of the Center for Integrated Circuit and Device Research (CIDR)",
      org: "Novotel, Araneta City, Quezon City",
      date: "August 11-12, 2025"
    }
  ];

  return (
    <div className="cert-page">
      {/* ── Header ── */}
      <header className="cert-header">
        <div className="cert-header-inner">
          <button className="cert-back-btn" onClick={onNavigateHome}>
            <span className="cert-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="cert-breadcrumb">
            <span className="cert-bc-home" onClick={onNavigateHome}>Home</span>
            <span className="cert-bc-sep">/</span>
            <span className="cert-bc-current">Certificates</span>
          </nav>
        </div>
      </header>

      {/* ── Hero Strip ── */}
      <div className="cert-hero-strip">
        <div className="cert-strip-inner">
          <p className="cert-strip-label scroll-animate-hero" data-delay="0">Continuous Learning</p>
          <h1 className="cert-strip-name scroll-animate-hero" data-delay="100">Seminars <span style={{fontFamily: "'Inter', sans-serif"}}>&amp;</span> Certifications</h1>
          <p className="cert-strip-role scroll-animate-hero" data-delay="200">Workshops, webinars, and conferences I have attended.</p>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="cert-main">
        <div className="cert-grid">
          {certs.map((item, idx) => (
            <div className="cert-card scroll-animate" key={idx} data-delay={idx * 80}>
              <div className="cert-icon-wrapper">
                <span className="cert-icon">&#127891;</span>
              </div>
              <div className="cert-content">
                <h3 className="cert-title">{item.title}</h3>
                <div className="cert-meta">
                  <span className="cert-org">{item.org}</span>
                  <span className="cert-dot">•</span>
                  <span className="cert-date">{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="cert-footer scroll-animate">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="cert-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Certificates;
